<script>
import Layout from '@layouts/main'
import api from '@utils/api'
import SerialSearch from '@components/serial-search'
import { createBarcodeScanner, isMobile } from '@utils/barcode/barcode-scanner'
import { getGoodsGroup } from '@utils/goods-group'

export default {
  name: 'SearchPLug',
  components: {
    Layout,
    SerialSearch,
  },
  data() {
    return {
      serial: null,
      loading: false,
      warehouse: null,
      document: null,
      info: null,
      inMyOrganization: false,
      error: null,
      scannerIsVisible: false,
      barcodeScanner: createBarcodeScanner(document),
      isMobile: isMobile(),
      deviceType: null,
      deviceTypes: this.getPlugOrTransmitterGroup(),
    }
  },
  computed: {
    goods() {
      return this.$store.getters['data/getDictionary']('goods')
    },
  },
  watch: {
    deviceType() {
      this.serial = this.getSerial()
      if (this.serial) {
        this.info = null
        this.warehouse = null
        this.document = null
        this.searchBySerial()
      }
    },
  },
  mounted() {
    this.deviceType = this.getDeviceType(this.$route.params.goodsGroup) || 2
  },
  methods: {
    getPlugOrTransmitterGroup() {
      return this.$store.getters['data/getDictionary']('goodsgroup').filter(
        el => el.code === 2 || el.code === 3
      )
    },
    setSerial(value) {
      this.serial = value
      this.searchBySerial()
    },
    async searchBySerial() {
      this.loading = true
      this.error = null
      const warehouses = await this.getWarehouse()
      if (!warehouses.content.length) {
        this.warehouse = null
        this.document = null
        this.info = null
        this.loading = false
        this.error = 'error__serial_not_found'
        return
      }
      this.warehouse = warehouses.content.find(
        item =>
          this.getDeviceType(getGoodsGroup(this.goods, item.goods)) ===
          this.deviceType
      )
      if (!this.warehouse) {
        this.loading = false
        this.error = 'error__serial_not_found'
        return
      }
      this.document = await this.getDocument(this.warehouse.document)
      await this.getGoods()
      this.loading = false
    },
    getWarehouse() {
      return api
        .getItems('warehouse', {
          filter_serial_value: this.serial,
          filter_serial_comparison: 'EQ',
          filter_writeoff_value: 'false',
          filter_writeoff_comparison: 'EQ',
          filter_quantity_value: '0',
          filter_quantity_comparison: 'NE',
          size: 10000,
          sort_property: 'createTime',
          sort_direction: 'DESC',
          page: 1,
        })
        .then(response => response)
    },
    getDocument(id) {
      return api.getItemById('document', id).then(response => response)
    },
    async getGoods() {
      this.inMyOrganization = false
      let result = await api
        .getGoodsBySerialV1({
          serial: this.serial,
          in_my_organization: this.inMyOrganization,
        })
        .then(response => {
          let pdoOrTransmitter = response.data.find(
            item => item.groupCode === this.getDeviceForArticle()
          )
          if (!pdoOrTransmitter) {
            pdoOrTransmitter = response.data.find(
              item => this.deviceType === 2 && item.groupCode === 2
            )
          }
          return pdoOrTransmitter
        })
      if (!result) {
        this.inMyOrganization = true
        result = await api
          .getGoodsBySerialV1({
            serial: this.serial,
            in_my_organization: this.inMyOrganization,
          })
          .then(response => {
            let pdoOrTransmitter = response.data.find(
              item => item.groupCode === this.getDeviceForArticle()
            )
            if (!pdoOrTransmitter) {
              pdoOrTransmitter = response.data.find(
                item => this.deviceType === 2 && item.groupCode === 2
              )
            }
            return pdoOrTransmitter
          })
      }
      this.info = { ...result }
    },
    getDeviceForArticle() {
      return this.deviceType === 2 || this.deviceType === 6 ? 6 : 3
    },
    getValue(dictionaryName, value) {
      return this.$store.getters['data/getValueFromDictionary'](
        dictionaryName,
        value
      )
    },
    getState(type) {
      switch (type) {
        case 2:
          return 'label__shipped'
        case 1:
        case 4:
        case 8:
          return 'label__on_warehouse'
        default:
          break
      }
    },
    openBarcodeScanner(field, applyValueFn) {
      this.scannerIsVisible = true
      this.barcodeScanner.openScannerForField(
        value => applyValueFn(value),
        () => this.closeScanner()
      )
    },
    getSerial() {
      return this.$route.params.serial || this.serial
    },
    getDeviceType(sourceDeviceType) {
      if (sourceDeviceType === 5) {
        return 2
      }
      return sourceDeviceType
    },
    closeScanner() {
      this.barcodeScanner.closeScanner()
      this.scannerIsVisible = false
    },
  },
}
</script>

<template>
  <Layout>
    <v-layout row>
      <v-flex
        :class="$style.labelPosition"
        shrink>
        {{ $t(`navigation_links__searchFor`) }}
      </v-flex>
      <v-flex xs11>
        <v-radio-group
          v-model="deviceType"
          class="pt-0"
          color="primary">
          <v-radio 
            v-for="d in deviceTypes"
            :key="d.code"
            :label="$t('label__'+ d.name)"
            :value="d.code"
            :class="$style.radioAdoption"/>
      </v-radio-group></v-flex>
    </v-layout>
    <v-layout
      row
      align-center
    >
      <v-flex lg6>
        <serial-search
          :value="serial"
          :device-type = "deviceType"
          @selected="setSerial($event)"
        />
      </v-flex>
      <v-flex 
        v-if="isMobile" 
        shrink>
        <img
          class="barcodeScanIcon"
          src="@assets/images/barcode_scan_icon.png"
          @click="openBarcodeScanner('serial', setSerial)"
        >
      </v-flex>
    </v-layout>

    <v-layout
      row
      align-center
    >
      <v-flex lg6>

        <v-list 
          v-if="info"
          dense
          mb2>
          <v-subheader>{{ $t('label__status') }}</v-subheader>
          <v-list-tile>
            <v-layout 
              row 
              wrap>
              <v-flex xs6>{{ $t('label__document') }}</v-flex>
              <v-flex xs6>
                <router-link
                  :to="{ name: 'document', params: { documentType: 'all', documentId: document.id } }">
                  {{ document.id }}
                </router-link>
              </v-flex>
            </v-layout>
          </v-list-tile>
          <v-divider/>
          <v-list-tile>
            <v-layout 
              row 
              wrap>
              <v-flex xs6>{{ $t('label__organization') }}</v-flex>
              <v-flex xs6>
                <router-link
                  v-if="warehouse.organisation"
                  :to="{name:'organization', params: {orgId: warehouse.organisation}}">
                  {{ getValue('organization', warehouse.organisation) }}
                </router-link>
              </v-flex>
            </v-layout>
          </v-list-tile>
          <v-divider/>
          <v-list-tile>
            <v-layout 
              row 
              wrap>
              <v-flex xs6>{{ $t('label__organisationWarehouse') }}</v-flex>
              <v-flex xs6>
                <router-link
                  v-if="warehouse.organisationWarehouse"
                  :to="{name:'organization', params: {orgId: warehouse.organisationWarehouse}}">
                  {{ getValue('organization', warehouse.organisationWarehouse) }}
                </router-link>
              </v-flex>
            </v-layout>
          </v-list-tile>
          <v-divider/>
          <v-list-tile>
            <v-layout 
              row 
              wrap>
              <v-flex xs6>{{ $t('label__status') }}</v-flex>
              <v-flex xs6>{{ $t(getState(document.type)) }}</v-flex>
            </v-layout>
          </v-list-tile>
          <v-divider/>
          <v-list-tile>
            <v-layout 
              row 
              wrap>
              <v-flex xs6>{{ $t('label__own_organization') }}</v-flex>
              <v-flex xs6>{{ inMyOrganization ? $t('buttons__yes') : $t('buttons__no') }}</v-flex>
            </v-layout>
          </v-list-tile>
          <v-divider/>
          <v-list-tile v-if="deviceType === 2">
            <v-layout
              row
              wrap>
              <v-flex xs6>{{ $t('label__zeroAngleX') }}</v-flex>
              <v-flex 
                v-if="info.zeroAngleX" 
                xs6>{{ info.zeroAngleX }}°</v-flex>
            </v-layout>
          </v-list-tile>
          <v-divider/>
          <v-list-tile v-if="deviceType === 2">
            <v-layout
              row
              wrap>
              <v-flex xs6>{{ $t('label__zeroAngleY') }}</v-flex>
              <v-flex 
                v-if="info.zeroAngleY" 
                xs6>{{ info.zeroAngleY }}°</v-flex>
            </v-layout>
          </v-list-tile>

          <v-subheader>{{ $t('label__goods') }}</v-subheader>
          <v-list-tile>
            <v-layout 
              row 
              wrap>
              <v-flex xs6>{{ $t('label__article') }}</v-flex>
              <v-flex xs6>
                <router-link
                  v-if="info.goodsId"
                  :to="{name:'goodsItem', params: {goodsId: info.goodsId.toString()}}">
                  {{ info.goodsArticle }}
                </router-link>
              </v-flex>
            </v-layout>
          </v-list-tile>
          <v-divider/>
          <v-list-tile>
            <v-layout 
              row 
              wrap>
              <v-flex xs6>{{ $t('label__full_name') }}</v-flex>
              <v-flex xs6>{{ info.goodsName }}</v-flex>
            </v-layout>
          </v-list-tile>
          <v-divider/>
          <v-list-tile>
            <v-layout 
              row 
              wrap>
              <v-flex xs6>{{ $t('label__short_name') }}</v-flex>
              <v-flex xs6>{{ info.goodsShortName }}</v-flex>
            </v-layout>
          </v-list-tile>
          <v-divider/>
          <v-list-tile>
            <v-layout 
              row 
              wrap>
              <v-flex xs6>{{ $t('label__group') }}</v-flex>
              <v-flex xs6>{{ $t(`goodsgroup.${info.groupCode}.name`) }}</v-flex>
            </v-layout>
          </v-list-tile>
        </v-list>

        <div v-if="error">{{ $t(error) }}</div>
        <div v-if="loading">Loading..</div>

      </v-flex>
      <v-card
        v-show="scannerIsVisible"
        id="scanner-container"
        class="scannerContainer">
        <v-btn
          class="scannerCancelBtn"
          color="secondary"
          @click="closeScanner()"
        >
          {{ $t('buttons__cancel') }}
        </v-btn>
      </v-card>
      <div 
        v-if="scannerIsVisible"
        class="blurred"/>
    </v-layout>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
.radioAdoption > label {
  font-size: inherit;
  color: #444 !important;
}
.labelPosition {
  padding-top: 0.4rem;
  padding-right: 0.5rem;
}
</style>
